import { api } from '@/utils/api';

/** Assign the selected contacts to a sequence (from the search selection bar). */
export const useSequenceAssignMutation = () => {
  const utils = api.useUtils();
  return api.sequence.assign.useMutation({
    onSuccess: () => {
      void utils.sequence.list.invalidate();
      // Assigning enrolls people → the per-node face counts on the sequence graph AND the People list change.
      void utils.sequence.faces.invalidate();
      void utils.sequence.people.invalidate();
    },
  });
};

/** Remove contacts from a sequence (deletes their enrollment) — used by the per-face remove control. */
export const useSequenceRemoveMutation = () => {
  const utils = api.useUtils();
  return api.sequence.remove.useMutation({
    onSuccess: () => {
      // Removing unenrolls people → the per-node face piles on the sequence graph AND the People list change.
      void utils.sequence.faces.invalidate();
      void utils.sequence.people.invalidate();
    },
  });
};

/** Restart contacts' journeys (re-seed at the entry node + kick off) — used by the per-face restart control. */
export const useSequenceRestartMutation = () => {
  const utils = api.useUtils();
  return api.sequence.restart.useMutation({
    onSuccess: () => {
      // Restarting moves people back to the entry node → the per-node face piles AND the People list change.
      void utils.sequence.faces.invalidate();
      void utils.sequence.people.invalidate();
    },
  });
};
